<template lang="pug">
.form-step-four-event(:class="{ readonly }")
  q-icon.form-step-four-event-remove(
    :name="archiveMode ? 'restore' : 'close'",
    role="button",
    tabindex="0",
    @click.stop="handleEventAction",
    @keyup.enter.stop="handleEventAction",
    @keyup.space.stop="handleEventAction"
  )
  .form-step-four-event-title(@click="closeEvent($event)")
    .form-step-four-event-title-arrow
      q-icon(name="expand_more")
    .form-step-four-event-title-text {{ `${index + 1}. ${schedulerLocales["event"]}` }}
  .form-step-four-event-name-and-periodicity
    .form-step-four-event-name
      input-title(:title="schedulerLocales['eventName']", :required="true")
      q-input.form-step-one-name(
        v-model="eventEl.name",
        filled,
        no-error-icon,
        autocomplete="off",
        :readonly="readonly"
      )
        q-icon.cancel-string-field(
          name="cancel",
          v-if="eventEl.name && !readonly",
          @click.stop="resetEventName(eventEl)"
        )
    .form-step-four-event-periodicity
      input-title(:title="schedulerLocales['periodicity']", :required="true")
      q-input.form-step-one-name(:value="eventName", @click.stop="openPeriodForm", readonly, filled, no-error-icon)
    .form-step-four-event-checklist
      q-btn.form-step-four-event-checklist-button(
        unelevated,
        no-caps,
        icon="assignment",
        :disable="readonly",
        @click="openChecklistDialog"
      )
        span {{ schedulerLocales.checklist }}
        q-icon.q-ml-sm(v-if="eventEl.checklistId", name="done", size="18px")
    .form-step-four-event-buttons(v-if="!readonly", v-for="action in event.actions", :key="action.name")
      q-btn.form-step-four-event-buttons-item(
        @click="generateIssues(action.onclick?.attr ?? {}, action.name)",
        :class="action.clicked ? 'clicked' : ''",
        :disabled="action.clicked"
      ) {{ action.label }}

  checklist-dialog(
    v-if="checklistDialogOpened",
    :facility-id="facilityId",
    :checklist-id="eventEl.checklistId",
    :checklist-required="eventEl.checklistRequired",
    @close="checklistDialogOpened = false",
    @save="saveChecklist"
  )

  .form-step-four-event-periodicity-form(v-if="periodForm && !scheduleValidationLoading")
    .form-step-four-event-periodicity-form-periods
      select-field(
        :initialValue="eventEl.periodType.id",
        :options="periodTypeOptions",
        :multiple="false",
        :showCancel="false",
        :label="schedulerLocales['issuesPeriodicity']",
        :readonly="readonly",
        required,
        @change="val => updatePeriod(val, eventEl)"
      ) 
      .form-step-four-event-periodicity-form-periods-options(v-if="eventEl.periodType.id")
        .form-step-four-event-periodicity-form-periods-option(
          v-for="periodOption in eventEl.period",
          :key="periodOption.id",
          @click="selectPeriodOption(periodOption)",
          :class="{ selected: periodOption.selected }"
        ) {{ periodOption.title }}
      .form-step-four-event-periodicity-form-period
        .form-step-four-event-periodicity-form-period-from
          input-title(:title="schedulerLocales['startedAt']", :required="true")
          date-field(
            :value="eventEl.startedAt",
            :minDate="todaysDate",
            :withWrapper="true",
            :disable="readonly",
            @select-date="selectStartDate",
            :event="eventEl"
          )
        .form-step-four-event-periodicity-form-period-to
          input-title(:title="schedulerLocales['finishedAt']", :required="true")
          date-field(
            :value="eventEl.finishedAt",
            :minDate="eventEl.startedAt",
            :withWrapper="true",
            :disable="readonly",
            @select-date="selectFinishDate",
            :event="eventEl"
          )
      .form-step-four-event-periodicity-form-deadline
        input-title(:title="schedulerLocales['deadline']", :required="true")
        q-input(
          v-model="eventEl.deadline",
          type="number",
          filled,
          no-error-icon,
          autocomplete="off",
          :readonly="readonly"
        )
    q-icon.form-step-four-event-periodicity-form-close(name="close", @click.stop="closePeriodForm()")
    .form-step-four-event-periodicity-form-submit(v-if="!readonly", @click.stop="validateScheduleEvent()") {{ schedulerLocales["save"] }}
  .form-step-four-event-periodicity-form-loader(v-if="periodForm && scheduleValidationLoading")
    q-spinner(color="primary", size="3em")

  q-dialog(v-model="scheduleValidationModalShown", persistent)
    confirm-modal.schedule-event-validation-confirm(
      :class="{ 'schedule-event-validation-confirm--error': scheduleValidationStatus === 'error' }",
      :parentData="scheduleValidationModalData",
      @confirm="handleScheduleValidationConfirmation"
    )

  .form-step-four-event-works
    .form-step-four-event-works-left.close
      .form-step-four-event-works-title(@click="closeWorks($event)")
        .form-step-four-event-arrow
          q-icon(name="expand_more")
        .form-step-four-event-works-title-text {{ schedulerLocales["works"] }}
      .form-step-four-event-works-form(:class="{ readonly }")
        .form-step-four-event-works-column(v-if="!readonly")
          q-input.form-step-four-event-works-search(
            v-model="worksQuery",
            @input="val => searchWorks(eventEl, val)",
            filled
          )
            q-icon(name="search")
          .form-step-four-event-works-options(v-if="eventWorkLength > 0")
            .form-step-four-event-works-option(
              v-for="option in eventOptions",
              :key="option.id",
              :class="{ selected: option.selected }",
              @click="selectWork(eventEl, option)"
            ) 
              .form-step-four-event-works-option-icon
                q-icon(name="done")
              .form-step-four-event-works-option-text {{ option.title }}
            .form-step-four-event-works-observe-visibility(v-observe-visibility="reachedEndOfList")
          .form-step-four-event-works-options-plug(v-if="eventWorkLength === 0") {{ schedulerLocales["worksNotAllowed"] }}
        .form-step-four-event-works-options.selected(
          v-if="readonly ? eventWorks.length > 0 : eventWorkLength > 0 || worksQuery.length > 0",
          :class="{ readonly }"
        )
          .form-step-four-event-works-option(
            v-for="option in eventWorks",
            :key="option.id",
            :class="{ selected: option.selected }"
          ) 
            .form-step-four-event-works-option-name(@click="selectEventWork(option)")
              .form-step-four-event-works-option-icon
                q-icon(name="done")
              .form-step-four-event-works-option-text {{ option.title }}
            .form-step-four-event-works-option-count
              .form-step-four-event-works-option-count-minus(v-if="!readonly", @click="changeCount('-', option)") -
              .form-step-four-event-works-option-count-number {{ option.count + 1 }}
              .form-step-four-event-works-option-count-plus(v-if="!readonly", @click="changeCount('+', option)") +
            .form-step-four-event-works-option-standardhours {{ calculateHours(option.count + 1, option.standard_hours) }}
            .form-step-four-event-works-option-cost {{ getCalculateCost(option.count + 1, option.cost) }}
        .form-step-four-event-works-options-plug(v-if="readonly && eventWorks.length === 0") {{ schedulerLocales["worksNotAllowed"] }}
    .form-step-four-event-works-right
      .form-step-four-event-works-calculator
        .form-step-four-event-works-calculator-hours
          input-title(:title="schedulerLocales['worksNormhours']", :required="false")
          q-input.form-step-one-name(:value="getAllHours(eventEl)", filled, no-error-icon, :disable="true")
        .form-step-four-event-works-calculator-costs
          input-title(:title="schedulerLocales['worksCost']", :required="false")
          q-input.form-step-one-name(:value="getAllCosts(eventWorks)", filled, no-error-icon, :disable="true")
  .form-step-four-event-description
    input-title(:title="schedulerLocales['description']", :required="false")
    q-input(type="textarea", v-model="eventEl.description", filled, autogrow, :readonly="readonly")
</template>

<script setup>
import { computed, inject, ref, onBeforeMount } from "vue";
import i18n from "@/plugins/vue-i18n";
import { currentLocale } from "@/services/useLocales";
import { endOfDay, format, formatISO, parse, startOfDay } from "date-fns";
import selectField from "../../../../shared/general_components/fields/selectField";
import dateField from "../../../../shared/general_components/fields/dateField";
import inputTitle from "./inputTitle.vue";
import confirmModal from "../../../../shared/helpers/confirmModal.vue";
import checklistDialog from "./checklistDialog.vue";
import backend from "@/api";
import { handleError } from "@/services/handleErrors";
import { Notify } from "quasar";

const props = defineProps({
  index: { type: Number, default: () => 1 },
  event: { type: Object, default: () => {} },
  facilityId: { type: Number || null, default: null },
  readonly: { type: Boolean, default: false },
  archiveMode: { type: Boolean, default: false },
});
const emit = defineEmits(["remove-event", "restore-event"]);

const periodForm = ref(false);
const todaysDate = ref("");
const worksQuery = ref("");
const actions = ref(props.event.actions ?? []);
const scheduleValidationLoading = ref(false);
const scheduleValidationModalShown = ref(false);
const scheduleValidationStatus = ref("");
const scheduleValidationMessage = ref("");
const checklistDialogOpened = ref(false);

const schedulerLocales = computed(() => i18n["messages"][currentLocale.value]["scheduler"]);
const eventEl = computed(() => props.event);
const index = computed(() => props.index);
const eventWorkLength = computed(() => eventEl.value.works?.options?.length || 0);
const eventName = computed(() => eventEl.value.periodType.title || schedulerLocales.value["submit"]);
const eventWorks = computed(() => eventEl.value.works?.items || []);
const eventOptions = computed(() => eventEl.value.works?.options || []);
const readonly = computed(() => props.readonly);
const archiveMode = computed(() => props.archiveMode);
const scheduleValidationModalData = computed(() => ({
  message: scheduleValidationMessage.value,
  cancelLabel: schedulerLocales.value["correct"],
  confirmLabel:
    scheduleValidationStatus.value === "error" ? schedulerLocales.value["correct"] : schedulerLocales.value["save"],
}));

const removeEvent = () => {
  emit("remove-event", props.index);
};

const restoreEvent = () => {
  emit("restore-event", props.event.id);
};

const handleEventAction = () => {
  if (props.archiveMode) {
    restoreEvent();
    return;
  }

  removeEvent();
};

const { periodTypeOptions = ref([]) } = inject("formVariables", {});

const openPeriodForm = () => {
  periodForm.value = true;
};

const openChecklistDialog = () => {
  if (props.readonly) {
    return;
  }

  checklistDialogOpened.value = true;
};

const saveChecklist = checklist => {
  if (!props.readonly) {
    updateChecklist(eventEl.value, checklist);
  }
  checklistDialogOpened.value = false;
};

const getTodaysDate = () => {
  const date = new Date();
  todaysDate.value = format(date, "dd.MM.yyyy");
};

const reachedEndOfList = async reachedEnd => {
  if (reachedEnd && eventEl.value.works.hasNextPage) {
    await getWorks(eventEl.value, worksQuery.value);
  }
};

const closePeriodForm = () => {
  periodForm.value = false;
};

const selectPeriodOption = option => {
  if (!props.readonly) {
    setPeriodOptionSelected(option);
  }
};

const selectEventWork = option => {
  if (!props.readonly) {
    selectWork(eventEl.value, option);
  }
};

const parseScheduleDate = value => {
  const parsedDate = parse(value, "dd.MM.yyyy", new Date());

  if (!Number.isNaN(parsedDate.getTime())) {
    return parsedDate;
  }

  const fallbackDate = new Date(value);
  return Number.isNaN(fallbackDate.getTime()) ? null : fallbackDate;
};

const formatScheduleDate = (value, finishOfDay = false) => {
  if (!value) {
    return value;
  }

  const parsedDate = parseScheduleDate(value);

  if (!parsedDate) {
    return value;
  }

  return formatISO(finishOfDay ? endOfDay(parsedDate) : startOfDay(parsedDate));
};

const getScheduleEventValidationParams = () => ({
  period_type: eventEl.value.periodType.id,
  period: getSelectedEventPeriods(eventEl.value),
  started_at: formatScheduleDate(eventEl.value.startedAt),
  finished_at: formatScheduleDate(eventEl.value.finishedAt, true),
});

const validateScheduleEvent = async () => {
  if (props.readonly || scheduleValidationLoading.value) {
    return;
  }

  scheduleValidationLoading.value = true;

  try {
    const { data } = await backend.create("/api/v3/ppr/schedules/validate_schedule_event", "", {
      schedule_event: getScheduleEventValidationParams(),
    });
    const status = data?.status?.toLowerCase();

    if (status === "ok") {
      closePeriodForm();
      return;
    }

    if (status === "warning" || status === "error") {
      scheduleValidationStatus.value = status;
      scheduleValidationMessage.value = data.message || "";
      scheduleValidationModalShown.value = true;
      return;
    }

    throw new Error("Unknown schedule event validation status");
  } catch (err) {
    await handleError(err, { notify: true });
  } finally {
    scheduleValidationLoading.value = false;
  }
};

const handleScheduleValidationConfirmation = confirmed => {
  const shouldSave = scheduleValidationStatus.value === "warning" && confirmed;

  scheduleValidationModalShown.value = false;
  scheduleValidationStatus.value = "";
  scheduleValidationMessage.value = "";

  if (shouldSave) {
    closePeriodForm();
  }
};

const generateIssues = async (params, name) => {
  const scheduleId = params.schedule_id;
  const eventId = params.event_id;

  try {
    const { data } = await backend.create(`/api/v3/ppr/schedules/${scheduleId}/generate_issues`, "", {
      event_id: eventId,
    });

    if (data.message) Notify.create(data.message);
    actions.value = actions.value.map(item => {
      if (item.name === name) item.clicked = true;
      return item;
    });
  } catch (err) {
    await handleError(err, { notify: true });
  }
};

const roundValue = number => (number ? +number.toFixed(2) : null);
const calculateCostFallback = (count, cost) => (cost ? roundValue(count * cost) : null);
const calculateHoursFallback = (count, hours) => (hours ? roundValue(count * hours) : 0);
const getAllHoursFallback = event => {
  const total = (event.works?.items || []).reduce(
    (sum, work) => sum + calculateHoursFallback(work.count + 1, work.standard_hours),
    0,
  );
  return total ? roundValue(total) : null;
};
const getAllCostsFallback = items => {
  const total = items.reduce((sum, item) => sum + (calculateCostFallback(item.count + 1, item.cost) || 0), 0);
  return total ? `${roundValue(total)}₽` : null;
};
const toggleClosest = (mouseEvent, selector) => {
  mouseEvent.currentTarget.closest(selector)?.classList.toggle("close");
};

const formFunctions = inject("formFunctions", {});
const closeEvent = formFunctions.closeEvent || (mouseEvent => toggleClosest(mouseEvent, ".form-step-four-event"));
const closeWorks =
  formFunctions.closeWorks || (mouseEvent => toggleClosest(mouseEvent, ".form-step-four-event-works-left"));
const resetEventName = formFunctions.resetEventName || (() => {});
const updatePeriod = formFunctions.updatePeriod || (() => {});
const getAllHours = formFunctions.getAllHours || getAllHoursFallback;
const getAllCosts = formFunctions.getAllCosts || getAllCostsFallback;
const calculateHours = formFunctions.calculateHours || calculateHoursFallback;
const getCalculateCost = formFunctions.getCalculateCost || calculateCostFallback;
const setPeriodOptionSelected = formFunctions.setPeriodOptionSelected || (() => {});
const selectStartDate = formFunctions.selectStartDate || (() => {});
const selectFinishDate = formFunctions.selectFinishDate || (() => {});
const changeCount = formFunctions.changeCount || (() => {});
const selectWork = formFunctions.selectWork || (() => {});
const getWorks = formFunctions.getWorks || (() => {});
const searchWorks = formFunctions.searchWorks || (() => {});
const updateChecklist = formFunctions.updateChecklist || (() => {});
const getSelectedEventPeriods =
  formFunctions.getSelectedEventPeriods ||
  (event => (event.period || []).filter(period => period.selected).map(period => period.id));

onBeforeMount(() => {
  getTodaysDate();
});
</script>

<style lang="scss">
.form-step-four-event.readonly {
  .form-step-four-event-periodicity-form-periods-option,
  .form-step-four-event-works-option-name {
    cursor: default;
  }
}

.form-step-four-event-buttons {
  display: flex;
  justify-content: space-between;
  padding-top: 32px;

  &-item {
    height: 45px;
    width: fit-content;
    line-height: 45px;
    color: #fff;
    background-color: #5b7aff;
    border-radius: 10px;
    padding: 0 15px;
    min-width: 200px;
    cursor: pointer;
    text-transform: none;
    font-weight: 600;

    .q-btn__wrapper:before {
      box-shadow: none;
    }
  }
}

.form-step-four-event-periodicity-form-loader {
  min-height: 300px;
  margin-top: 20px;
  border: var(--ppr-scheduler-field-border);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.schedule-event-validation-confirm--error {
  .confirm-card-title span {
    color: #f44336;
  }

  .modal-form-cancel {
    display: none;
  }
}
</style>
